// extracted by mini-css-extract-plugin
export default {"ad__item":"AdItem_ad__item__Bau0s","ad__item__date":"AdItem_ad__item__date__3seAE","ad__item__text":"AdItem_ad__item__text__e1Ocd","ad__item__view":"AdItem_ad__item__view__J99sO"};